import React, { useState } from "react";
import { Card, Accordion, Button, Row, Col, Form } from "react-bootstrap";
import {
  downloadInvoice,
  cancelOrder,
  packOrder,
  getWeightText,
  getCartAmount,
  validateAddress,
  validateUserAttributes,
  getShippingNumber,
  getShippingCharges,
  isOrderDeliverable,
  createOrder,
  getProductAmountInCart,
  productIdExistsInCart,
  productWithPackagingExistsInCart,
  dispatchOrder,
} from "../../../../helper";
import ToggleButton from "../../../../components/ToggleButton/index";
import StorePickupOptions from "../../../../components/HomeForm/StorePickupOptions";
import HomeSearch from "../../../../components/HomeSearch/index";

export default function OrdersRow(props) {
  const { order, deleteEmptyOrder, index, fetchOrders } = props;
  const [given_name, setGivenName] = useState(null);
  const [username, setUsername] = useState(null);
  const [products, setProducts] = useState([]);
  const [addressLine1, setAddressLine1] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [pincode, setPincode] = useState(null);
  const [contactPerson, setContactPerson] = useState(null);
  const [alternateContactNumber, setAlternateContact] = useState(null);
  const [houseNumber, setHouseNumber] = useState(null);
  const [email, setEmail] = useState(null);
  const [shippingCharges, setShippingCharges] = useState(0);
  const [isStorePickup, setIsStorePickup] = useState(false);
  const [codApplied, setCodApplied] = useState(false);
  const { cartAmount } = getCartAmount(products);
  const [selectedStorePickupSlot, setSelectedStorePickupSlot] = useState(null);
  const [selectedStorePickupDate, setSelectedStorePickupDate] = useState(null);

  const getOrderProducts = () => {
    const productsArray = order.order_id ? order.products : products;
    return productsArray.map((element, index) => (
      <Row className="mt-2 mb-2">
        {index + 1}
        <Col>{element.product_name}</Col>
        <Col>
          {element.rate_amt
            ? getWeightText(Number(element.quantity * element.packaging))
            : `${element.quantity} Unit`}
        </Col>
        <Col>
          {`PKG:
        ${element.rate_amt ? getWeightText(element.packaging) : element.weight} 
        ${element.unit ? element.unit : ""}`}
        </Col>
        <Col>
          RS.
          {element.rate_amt || element.price_fixed}
        </Col>
        <Col>
          RS.
          {getProductAmountInCart(element)}
        </Col>
      </Row>
    ));
  };

  const addToCart = (product, quantity = null, packaging = null) => {
    product = Object.assign({}, product);
    const newProducts = Object.assign([], products);
    delete product.product_desc;
    if (quantity == null) {
      if (packaging) {
        product.packaging = packaging;
      }
      product.quantity = 1;
      newProducts.push(product);
    } else if (quantity >= 0) {
      const productUpdateIndex = packaging
        ? productWithPackagingExistsInCart(
            product.product_id,
            packaging,
            newProducts
          )
        : productIdExistsInCart(product.product_id, newProducts);
      if (productUpdateIndex != null) {
        quantity <= 0
          ? newProducts.splice(productUpdateIndex, 1)
          : (newProducts[productUpdateIndex].quantity = quantity);
      } else {
        product.quantity = quantity;
        if (packaging) {
          product.packaging = packaging;
        }
        newProducts.push(product);
      }
    }
    setProducts(newProducts);
  };

  const handleGetShippingCharges = () => {
    const requestAddress = {
      addressLine1: addressLine1,
      city,
      state,
      pincode,
      houseNumber,
    };
    const user_attributes = {
      username,
      email,
      given_name,
    };
    const validAddressResult = validateAddress(requestAddress);
    const validateUserAttributesResult = validateUserAttributes(
      user_attributes
    );
    const isDeliverable = isOrderDeliverable(products);

    if (
      validAddressResult === true &&
      validateUserAttributesResult === true &&
      isDeliverable
    ) {
      user_attributes.username = getShippingNumber(user_attributes.username);
      getShippingCharges({
        address: requestAddress,
        user_attributes,
        COD: codApplied ? 1 : 0,
        products: products,
      })
        .then((result) => setShippingCharges(Number(result)))
        .catch((error) => alert(error.response.data.error));
    } else {
      if (!isDeliverable) {
        alert(
          "The cart contains some items such as (Trousseau Items) that are not eligible for Home Delivery. Please remove these products from cart and retry calculating shipping charges"
        );
      }
      if (validAddressResult.error) {
        alert(validAddressResult.error);
      } else if (validateUserAttributesResult.error) {
        alert(validateUserAttributesResult.error);
      }
    }
  };

  const handlePlaceOrder = async () => {
    const shipping_charges = shippingCharges || 0;
    let payload = {
      user_attributes: { email, given_name, username },
      address: isStorePickup
        ? null
        : {
            houseNumber,
            addressLine1,
            city,
            state,
            pincode,
            alternateContact: alternateContactNumber,
            contactPerson,
          },
      products,
      is_store_pickup: isStorePickup || false,
      product_charges: cartAmount,
      processing_fee: 0,
      shipping_charges,
      total_amount: shipping_charges + cartAmount,
      payment_method: codApplied ? "COD" : "Razorpay",
    };
    if (isStorePickup) {
      payload["pickup_date"] = selectedStorePickupDate;
      payload["pickup_slot"] = selectedStorePickupSlot;
    }
    await createOrder(payload)
      .then(async () => await fetchOrders())
      .then(() => alert("Order placed successfully"));
  };

  return (
    <div className="d-flex justify-content-around">
      <Card className="w-100">
        <Accordion.Toggle
          as={Card.Header}
          variant="link"
          eventKey={order.order_id || `new-order-${index}`}
        >
          <Row>
            {order.order_id ? (
              <>
                <Col>{order.order_id}</Col>
                <Col>{order.create_date}</Col>
                <Col>{order.user_attributes.given_name}</Col>
                <Col>{order.user_attributes.username}</Col>
                <Col>
                  {order.is_store_pickup ? "Store Pickup" : "Home Delivery"}
                </Col>
                <Col>{order.order_status}</Col>
                <Col>{order.total_amount}</Col>
                <Col>{order.payment_method}</Col>
              </>
            ) : (
              "New Order"
            )}
          </Row>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={order.order_id || `new-order-${index}`}>
          <Card.Body>
            <h4>User Attributes</h4>
            <Row>
              <Col>
                Name:
                {order.user_attributes.given_name ? (
                  order.user_attributes.given_name
                ) : (
                  <Form.Control
                    type="text"
                    value={given_name}
                    onChange={(event) => setGivenName(event.target.value)}
                  />
                )}
              </Col>
              <Col>
                Username/Phone Number:
                {order.user_attributes.username ? (
                  order.user_attributes.username
                ) : (
                  <Form.Control
                    type="number"
                    value={username}
                    onChange={(event) => setUsername(event.target.value)}
                  />
                )}
              </Col>
              <Col>
                Email:
                {order.user_attributes.email ? (
                  order.user_attributes.email
                ) : (
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                )}
              </Col>
            </Row>
            <hr /> <h4>User Address</h4>
            {order.address ? (
              <Row>
                {Object.keys(order.address).map(
                  (element) =>
                    element !== "location" &&
                    order.address[element] && (
                      <Col>
                        {element}: {String(order.address[element])}
                      </Col>
                    )
                )}
              </Row>
            ) : order.is_store_pickup || isStorePickup ? (
              <Row>
                <Col>Store Pickup Selected</Col>
                <Col>
                  Store Pickup Date:
                  {order.order_id ? order.pickup_date : selectedStorePickupDate}
                </Col>
                <Col>
                  Store Pickup Slot:
                  {order.order_id ? order.pickup_slot : selectedStorePickupSlot}
                </Col>
              </Row>
            ) : (
              <>
                <Row>
                  <Col>
                    <Form.Control
                      placeholder="Address Line 1"
                      type="text"
                      value={addressLine1}
                      onChange={(event) => setAddressLine1(event.target.value)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      placeholder="House Number"
                      type="text"
                      value={houseNumber}
                      onChange={(event) => setHouseNumber(event.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Control
                      placeholder="City"
                      type="text"
                      value={city}
                      onChange={(event) => setCity(event.target.value)}
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      placeholder="State"
                      type="text"
                      value={state}
                      onChange={(event) => setState(event.target.value)}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Control
                      placeholder="Pincode"
                      type="number"
                      value={pincode}
                      onChange={(event) => setPincode(event.target.value)}
                    />
                  </Col>
                  <Col></Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Control
                      placeholder="Alternate Contact Number"
                      type="text"
                      value={alternateContactNumber}
                      onChange={(event) =>
                        setAlternateContact(event.target.value)
                      }
                    />
                  </Col>
                  <Col>
                    <Form.Control
                      placeholder="Contact Person Name"
                      type="text"
                      value={contactPerson}
                      onChange={(event) => setContactPerson(event.target.value)}
                    />
                  </Col>
                </Row>
              </>
            )}
            <hr /> <h4>Order Charges</h4>
            <Row>
              <Col>
                {!order.order_id && (
                  <ToggleButton
                    secondLabel="Store Pickup"
                    firstLabel="Home Delivery"
                    checkedValue={isStorePickup}
                    handleOnChange={() => {
                      setIsStorePickup(!isStorePickup);
                      setSelectedStorePickupDate(null);
                      setSelectedStorePickupSlot(null);
                    }}
                  />
                )}
                {isStorePickup ? (
                  <StorePickupOptions
                    selectedStorePickupSlot={selectedStorePickupSlot}
                    setSelectedStorePickupSlot={setSelectedStorePickupSlot}
                    selectedStorePickupDate={selectedStorePickupDate}
                    setSelectedStorePickupDate={setSelectedStorePickupDate}
                  />
                ) : (
                  <div className="d-flex">
                    <p>
                      {`Shipping Charges: Rs ${
                        order.order_id
                          ? order.shipping_charges
                          : shippingCharges
                      }`}
                    </p>
                    {!order.order_id && (
                      <Button
                        className="ml-2"
                        onClick={handleGetShippingCharges}
                      >
                        Calculate Shipping Charges
                      </Button>
                    )}
                  </div>
                )}
              </Col>
              <Col>
                Product Charges: Rs
                {order.order_id ? order.product_charges : cartAmount}
              </Col>
              {!codApplied &&
                (order.order_id || order.payment_method !== "COD") && (
                  <Col>
                    Processing Charges: Rs
                    {order.order_id ? order.processing_fee : 0}
                  </Col>
                )}
              {(order.is_store_pickup || isStorePickup) && (
                <>
                  <Col>
                    Pickup Advance:
                    {order.is_store_pickup
                      ? 0.1 * order.total_amount
                      : 0.1 * cartAmount}
                  </Col>
                  <Col>
                    Balance:
                    {order.is_store_pickup
                      ? order.total_amount - 0.1 * order.total_amount
                      : cartAmount - 0.1 * cartAmount}
                  </Col>
                </>
              )}
              <Col>
                Total Amount: Rs
                {order.order_id
                  ? order.total_amount
                  : cartAmount + shippingCharges}
              </Col>
            </Row>
            <hr />
            <Row>
              <h4>Total Products: {order.products.length}</h4>
            </Row>
            <Row>
              <Col>Name</Col>
              <Col>Quantity</Col>
              <Col>Packaging</Col>
              <Col>Unit Price</Col>
              <Col>Price</Col>
            </Row>
            {!order.order_id && (
              <HomeSearch
                cart={products}
                addToCart={addToCart}
                backend={true}
              />
            )}
            {getOrderProducts()}
            <hr />
            {order.order_id ? (
              <>
                <h4>Order Action</h4>
                <Row>
                  <Col>
                    <Button
                      disabled={
                        ["Cancelled", "Dispatched"].includes(
                          order.order_status
                        ) || order.is_store_pickup
                      }
                      onClick={async () => {
                        let user_attributes = Object.assign(
                          {},
                          order.user_attributes
                        );
                        if (
                          "contactPerson" in order.address &&
                          order.address.contactPerson !== null
                        ) {
                          user_attributes["given_name"] =
                            order.address.contactPerson;
                        }
                        if (
                          "alternateContact" in order.address &&
                          order.address.alternateContact
                        ) {
                          user_attributes["username"] = getShippingNumber(
                            order.address.alternateContact
                          );
                        }
                        const payload = {
                          user_attributes,
                          address: order.address,
                          COD: order.payment_method === "Razorpay" ? 0 : 1,
                          products: order.products,
                          total_amount: order.total_amount,
                        };
                        await dispatchOrder(
                          order.order_id.substring(4),
                          payload
                        ).then((res) => res && fetchOrders());
                      }}
                    >
                      Dispatch
                    </Button>
                  </Col>
                  {order.dispatch_id && (
                    <Col>Dispatch Id: {order.dispatch_id}</Col>
                  )}
                  <Col>
                    <Button
                      disabled={["Cancelled", "Dispatched"].includes(
                        order.order_status
                      )}
                      onClick={() =>
                        cancelOrder(order.order_id.substring(4), {
                          razorpay_payment_id: order.razorpay_payment_id,
                          user_attributes: {
                            email: order.user_attributes.email,
                          },
                        })
                          .then(() => alert("Cancelled"))
                          .then(() => fetchOrders())
                      }
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      onClick={async () => {
                        ["Received", "Payment Incomplete"].includes(
                          order.order_status
                        ) &&
                          (await packOrder(
                            order.order_id.substring(4)
                          ).then(() => fetchOrders()));

                        await downloadInvoice(order);
                      }}
                    >
                      {(["Received", "Payment Incomplete"].includes(
                        order.order_status
                      )
                        ? "Pack && "
                        : "") + "Download Invoice"}
                    </Button>
                  </Col>
                </Row>
              </>
            ) : (
              <div className="d-flex justify-content-around">
                {!order.order_id && (
                  <ToggleButton
                    secondLabel="COD"
                    firstLabel="Prepaid"
                    checkedValue={codApplied}
                    handleOnChange={() => setCodApplied(!codApplied)}
                  />
                )}
                <Button onClick={handlePlaceOrder}>Create Order</Button>
                <Button onClick={deleteEmptyOrder}>Cancel Create Order</Button>
              </div>
            )}
            <hr />
            {order.razorpay_order_id && (
              <>
                <h4>Razorpay</h4>
                <Row>
                  <Col>Razorpay Payment Id: {order.razorpay_payment_id}</Col>
                  <Col>Razorpay Payment Status: {order.razorpay_status}</Col>
                  <Col>
                    Razorpay Payment Order Id: {order.razorpay_order_id}
                  </Col>
                </Row>
              </>
            )}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </div>
  );
}
